export const EnumConciliationStatusType = {
    CORTANDO: "cortando",
    A_CONCILIAR: "a_conciliar",
    CONCILIANDO: "conciliando",
    CONCILIADO: "conciliado",
    CONCLUINDO: "concluindo",
    ERRO: "erro",
} as const;
  
  